module.exports = __webpack_public_path__ + "static/media/buoy-yellow.8e81cbd8.png";